import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { loadStoreState, setInitialStoreState } from '../../../../../common';
import { WaybillIdView } from '../../../../models';
import { ShipmentWaybillItemFacade } from '../shipment-waybill-item.facade';
import { ShipmentWaybillForeignTradeFacade } from './shipment-waybill-foreign-trade.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillForeignTradeGuard {
  constructor(
    private shipmentWaybillForeignTradeFacade: ShipmentWaybillForeignTradeFacade,
    private shipmentWaybillItemFacade: ShipmentWaybillItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentWaybillItemFacade.shipmentWaybillIdentifier$.pipe(
      switchMap((identifier: WaybillIdView) => {
        return loadStoreState(this.shipmentWaybillForeignTradeFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentWaybillForeignTradeFacade);
  }
}
